function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { BreakpointModalWidths, CloseButtonSides, ContentPadding, Sizes } from './constants';
import { Breakpoints, Spacing, Text, ThemingContext } from '@doordash/design-language';
import { ModalCloseButtonContainer, ModalContainer, ModalContentContainer, ModalFooter, ModalFooterContainer, ModalContent as StyledModalContent } from './styles';
import { breakpointForScreenWidth, getModalPadding } from './utils';
import { getPropsToForward, withUniqueId } from '@doordash/utilities';
import { getMobileDevice } from './getEnvironmentConstants';
import Button from '@doordash/component-button';
import CloseButton from './header/CloseButton';
import DefaultContentHeader from './header/DefaultContentHeader';
import ExecutionEnvironment from 'exenv';
import PropTypes from 'prop-types';
import React from 'react';
import StickyHeader from './header/StickyHeader';
import get from 'lodash.get';
import omit from 'lodash.omit';
export var MODAL_FOOTER_ID = 'prism-modal-footer';

var getTitleId = function getTitleId(uniqueId) {
  return "".concat(uniqueId, "-Title");
};

var getSubtitleId = function getSubtitleId(uniqueId) {
  return "".concat(uniqueId, "-Subtitle");
};

var PREFIX_ID = 'ModalContent';

var ModalContent = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ModalContent, _React$PureComponent);

  var _super = _createSuper(ModalContent);

  function ModalContent() {
    var _this;

    _classCallCheck(this, ModalContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      topScrolled: false,
      bottomScrolled: false,
      footerPadding: 0,
      clientHeight: get(document, 'documentElement.clientHeight', window.innerHeight),
      viewportHeight: window.innerHeight,
      viewportWidth: window.innerWidth,
      windowBreakpoint: breakpointForScreenWidth(window.innerWidth)
    });

    _defineProperty(_assertThisInitialized(_this), "setContentElement", function (el) {
      _this.contentElement = el;
    });

    _defineProperty(_assertThisInitialized(_this), "setFooterElement", function (el) {
      _this.footerElement = el;
    });

    _defineProperty(_assertThisInitialized(_this), "setTitleElement", function (el) {
      _this.titleElement = el;
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      _this.calculateScrollState(_this.contentElement);

      if (_this.props.isFooterFixedPosition) {
        _this.setFooterPadding(_this.footerElement);
      }

      if (window.innerHeight !== _this.state.viewportHeight || document.documentElement.clientHeight !== _this.state.clientHeight) {
        _this.setState({
          clientHeight: get(document, 'documentElement.clientHeight', window.innerHeight),
          viewportHeight: window.innerHeight
        });
      }

      if (window.innerWidth !== _this.state.viewportWidth) {
        var windowSize = breakpointForScreenWidth(window.innerWidth);

        if (windowSize !== _this.state.windowBreakpoint) {
          _this.setState({
            windowBreakpoint: windowSize,
            modalPadding: ContentPadding[windowSize]
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function (event) {
      _this.calculateScrollState(event.target);
    });

    _defineProperty(_assertThisInitialized(_this), "isMobileViewport", function () {
      return !!(window.innerWidth <= Breakpoints.Mobile);
    });

    _defineProperty(_assertThisInitialized(_this), "isIOSDevice", function () {
      var deviceOS = getMobileDevice();
      return !!(deviceOS === 'iOS');
    });

    _defineProperty(_assertThisInitialized(_this), "calculateScrollState", function (scrollElement) {
      var scrollTop = scrollElement.scrollTop,
          scrollHeight = scrollElement.scrollHeight,
          offsetHeight = scrollElement.offsetHeight;

      if (typeof scrollTop !== 'undefined' && typeof scrollHeight !== 'undefined' && typeof offsetHeight !== 'undefined') {
        _this.setState({
          topScrolled: scrollTop > _this.titleElement.offsetTop + _this.titleElement.offsetHeight,
          bottomScrolled: scrollTop + offsetHeight < scrollHeight
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setFooterPadding", function (footerElement) {
      if (footerElement === null || typeof footerElement === 'undefined' || !_this.isMobileViewport()) return;

      _this.setState({
        footerPadding: footerElement.offsetHeight
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDocumentKeydown", function (event) {
      var _this$props = _this.props,
          onClose = _this$props.onClose,
          shouldCloseOnEscapePress = _this$props.shouldCloseOnEscapePress;

      if (onClose && shouldCloseOnEscapePress && event.keyCode === 27) {
        onClose();
      }
    });

    return _this;
  }

  _createClass(ModalContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (ExecutionEnvironment.canUseDOM) {
        this.calculateScrollState(this.contentElement);
        requestAnimationFrame(function () {
          return _this2.setFooterPadding(_this2.footerElement);
        });
        document.addEventListener('keydown', this.handleDocumentKeydown);
        window.addEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.children !== this.props.children) {
        // A common use-case for Modals is to display a "loading" Modal
        // while content is being fetched, and then replacing the content
        // with the fetched content. This check ensures that we're displaying
        // the proper shadows for the footer if the children update.
        this.calculateScrollState(this.contentElement);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (ExecutionEnvironment.canUseDOM) {
        document.removeEventListener('keydown', this.handleDocumentKeydown);
        window.removeEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          closeButtonSide = _this$props2.closeButtonSide,
          customSize = _this$props2.customSize,
          headerAlignment = _this$props2.headerAlignment,
          children = _this$props2.children,
          hasContentPadding = _this$props2.hasContentPadding,
          hasHeaderPadding = _this$props2.hasHeaderPadding,
          headerImage = _this$props2.headerImage,
          actionsFillContainer = _this$props2.actionsFillContainer,
          primaryAction = _this$props2.primaryAction,
          hasCloseButton = _this$props2.hasCloseButton,
          onClose = _this$props2.onClose,
          secondaryAction = _this$props2.secondaryAction,
          size = _this$props2.size,
          subtitle = _this$props2.subtitle,
          subtitleSize = _this$props2.subtitleSize,
          title = _this$props2.title,
          titleSize = _this$props2.titleSize,
          uniqueId = _this$props2.uniqueId,
          role = _this$props2.role,
          ModalContentHeader = _this$props2.renderContentHeader,
          renderFooterContent = _this$props2.renderFooterContent,
          shouldRenderStickyHeader = _this$props2.shouldRenderStickyHeader,
          shouldStackButtons = _this$props2.shouldStackButtons,
          isFullScreenOnMobile = _this$props2.isFullScreenOnMobile,
          isFooterFixedPosition = _this$props2.isFooterFixedPosition,
          useHairlineDividersProp = _this$props2.useHairlineDividers,
          props = _objectWithoutProperties(_this$props2, ["closeButtonSide", "customSize", "headerAlignment", "children", "hasContentPadding", "hasHeaderPadding", "headerImage", "actionsFillContainer", "primaryAction", "hasCloseButton", "onClose", "secondaryAction", "size", "subtitle", "subtitleSize", "title", "titleSize", "uniqueId", "role", "renderContentHeader", "renderFooterContent", "shouldRenderStickyHeader", "shouldStackButtons", "isFullScreenOnMobile", "isFooterFixedPosition", "useHairlineDividers"]);

      var closeButtonAccessibilityLabel = "Close ".concat(title, " modal");
      var closeSide = closeButtonSide || get(this.context, 'Modal.closeButtonSide');
      var modalPadding = getModalPadding(get(this.context, 'Modal.hasDynamicPadding'), this.state.windowBreakpoint);
      var modalBackgroundColor = get(this.context, 'Colors.ModalBackground');
      var modalBorderRadius = get(this.context, 'BorderRadius.ModalDefault'); // By default we want to use the theme value for hairlines,
      // but we also want to allow an instance level override.

      var useHairlineDividers = get(this.context, 'Modal.useHairlineDividers');

      if (typeof useHairlineDividersProp !== 'undefined') {
        useHairlineDividers = useHairlineDividersProp;
      } // `windowContentOffset` is calculated to ensure a fixed footer
      // is fully visible at the bottom of the page, even if an iOS
      // Smart Banner is displaying in the browser and shifting the
      // screen content down
      // When a smart banner is displayed and the keyboard comes up, this triggers
      // a resize event to push the banner off of the screen. We want to confirm that
      // the resize is not due to a keyboard coming up, so we check that the difference
      // between the two is smaller than 100, which will account for the virtual keyboard
      // but not for a smart banner or the address bar resizing


      var windowContentOffset = this.state.clientHeight > this.state.viewportHeight && this.state.clientHeight - this.state.viewportHeight < 100 ? this.state.clientHeight - this.state.viewportHeight : 0;
      var fullscreenMobileBottomPadding = this.state.footerPadding + windowContentOffset + Spacing.XxLarge;
      var propsToForward = getPropsToForward({
        props: props
      });
      return /*#__PURE__*/React.createElement(ModalContainer, _extends({
        isFooterFixedPosition: isFooterFixedPosition,
        bottomLocation: windowContentOffset,
        modalBackgroundColor: modalBackgroundColor,
        modalBorderRadius: modalBorderRadius,
        size: size,
        modalPadding: modalPadding,
        modalWidth: this.state.windowBreakpoint && BreakpointModalWidths[this.state.windowBreakpoint][size],
        role: role,
        "aria-modal": "true",
        "aria-labelledby": getTitleId(uniqueId),
        "aria-describedby": getSubtitleId(uniqueId),
        isFullScreenOnMobile: isFullScreenOnMobile // Due to the way iOS Safari handles the expanding and collapsing
        // for the browser address bar and bottom navigation on mobile devices,
        // these two properties may be different. We want to use the smaller
        // of the two to ensure that Modal content is not obscured by the browser
        // because one is larger than the "actual, available" real estate
        ,
        viewportHeight: Math.min(this.state.clientHeight, this.state.viewportHeight),
        customSize: customSize
      }, propsToForward), /*#__PURE__*/React.createElement("span", {
        "aria-label": title,
        "aria-live": "polite",
        tabIndex: 0
      }), hasCloseButton && !this.state.topScrolled && (ModalContentHeader !== DefaultContentHeader || headerImage) && /*#__PURE__*/React.createElement(ModalCloseButtonContainer, {
        closeButtonSide: closeSide,
        isFloating: !!headerImage,
        hasHeaderImage: !!headerImage,
        hasCustomHeader: ModalContentHeader !== DefaultContentHeader,
        modalPadding: modalPadding
      }, /*#__PURE__*/React.createElement(CloseButton, {
        closeButtonAccessibilityLabel: closeButtonAccessibilityLabel,
        onClose: onClose
      })), shouldRenderStickyHeader && this.state.topScrolled && /*#__PURE__*/React.createElement(StickyHeader, {
        closeButtonAccessibilityLabel: closeButtonAccessibilityLabel,
        modalBackgroundColor: modalBackgroundColor,
        modalBorderRadius: modalBorderRadius,
        isFullScreenOnMobile: isFullScreenOnMobile,
        closeButtonSide: closeSide,
        modalPadding: modalPadding,
        onClose: onClose,
        hasCloseButton: hasCloseButton,
        headerAlignment: headerAlignment,
        title: title,
        useHairlineDividers: useHairlineDividers
      }), /*#__PURE__*/React.createElement(ModalContentContainer, {
        hasPadding: hasContentPadding,
        onScroll: this.handleScroll,
        modalPadding: modalPadding,
        innerRef: this.setContentElement // To Do (lindsey-menges): update this logic to also account
        // for the presence of an optional harline divider for the footer
        // when implemented to ensure content does not press up
        // against footer container
        ,
        hasFooter: !!primaryAction || !!renderFooterContent,
        isFooterFixedPosition: isFooterFixedPosition
      }, /*#__PURE__*/React.createElement(ModalContentHeader, {
        closeButtonSide: closeSide,
        closeButtonAccessibilityLabel: closeButtonAccessibilityLabel,
        title: /*#__PURE__*/React.createElement("span", {
          ref: this.setTitleElement
        }, title),
        titleSize: titleSize,
        subtitle: subtitle,
        subtitleSize: subtitleSize,
        onClose: onClose,
        headerAlignment: headerAlignment,
        headerImage: headerImage,
        hasContent: !!children,
        titleId: getTitleId(uniqueId),
        subtitleId: getSubtitleId(uniqueId),
        hasPadding: hasContentPadding || hasHeaderPadding,
        modalPadding: modalPadding,
        hasCloseButton: hasCloseButton,
        useHairlineDividers: useHairlineDividers
      }), children && /*#__PURE__*/React.createElement(StyledModalContent, {
        hasPadding: hasContentPadding,
        modalPadding: modalPadding // You need to be able to account for the footer
        // being out of normal flow on fullscreen treatments
        // by adding additional padding to the content's
        // container within the scrollview:
        ,
        style: isFooterFixedPosition && isFullScreenOnMobile && this.isIOSDevice() ? {
          paddingBottom: fullscreenMobileBottomPadding * 2 // NOTE: May be able to update this value to be the difference
          // of window.outerHeight and window.innerHeight, plus the height
          // of the fixed footer. This value ^ seems to work without issue,
          // but could update logic to be more consistent/based on device values

        } : undefined // Don't provide any style if not fixed

      }, children)), (!!primaryAction || !!renderFooterContent) && /*#__PURE__*/React.createElement(ModalFooterContainer, {
        modalSize: size,
        modalPadding: modalPadding,
        isFooterFixedPosition: isFooterFixedPosition,
        isFullScreenOnMobile: isFullScreenOnMobile,
        mobileBottomLocation: windowContentOffset
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.setFooterElement
      }, /*#__PURE__*/React.createElement(ModalFooter, {
        id: MODAL_FOOTER_ID,
        inlineActionButtonSpacing: get(this.context, 'Spacing.ModalActionButtonsInline'),
        modalBackgroundColor: modalBackgroundColor,
        modalBorderRadius: modalBorderRadius,
        modalPadding: modalPadding,
        shouldStackButtons: shouldStackButtons,
        showDivider: this.state.bottomScrolled,
        actionsFillContainer: actionsFillContainer,
        isFullScreenOnMobile: isFullScreenOnMobile,
        useHairlineDividers: useHairlineDividers,
        isSquished: true // To account for the placement of browser elements in iOS (Safari in
        // particular), we are setting an `env()` variable for the footer's bottom
        // padding on mobile based on the safe inset area. `env()` is not available
        // on IE11, and we only need to apply this padding for mobile iOS devices,
        // so we check if this is a fullscreen Modal being rendered on an iOS device
        // to prevent any styling issues if `env()` is not supported.
        ,
        isIOSFixedFullscreen: this.isIOSDevice() && isFooterFixedPosition && isFullScreenOnMobile
      }, !!renderFooterContent && renderFooterContent(), !!secondaryAction && /*#__PURE__*/React.createElement(Button, _extends({
        type: Button.Types.Tertiary,
        isInline: true,
        onClick: secondaryAction.onClick
      }, secondaryAction.buttonProps), secondaryAction.text), !!primaryAction && /*#__PURE__*/React.createElement(Button, _extends({
        isInline: true,
        padding: actionsFillContainer ? Button.Padding.Narrow : Button.Padding.Wide,
        onClick: primaryAction.onClick
      }, primaryAction.buttonProps), primaryAction.text)))));
    }
  }]);

  return ModalContent;
}(React.PureComponent);

_defineProperty(ModalContent, "contextType", ThemingContext);

ModalContent.CloseButtonSides = CloseButtonSides;
ModalContent.Sizes = Sizes;
ModalContent.HeaderAlignment = omit(Text.TextAlignments, ['Right', 'Justify']);
var ACTION_PROP = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  buttonProps: PropTypes.object
};
var CUSTOM_SIZE_PROP = {
  maxHeight: PropTypes.number,
  maxWidth: PropTypes.number
};
ModalContent.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  titleSize: PropTypes.number,
  subtitleSize: PropTypes.number,
  children: PropTypes.node,
  actionsFillContainer: PropTypes.bool,
  isFullScreenOnMobile: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(ModalContent.Sizes)),
  headerAlignment: DefaultContentHeader.propTypes.headerAlignment,
  primaryAction: PropTypes.shape(ACTION_PROP),
  secondaryAction: PropTypes.shape(ACTION_PROP),
  headerImage: PropTypes.node,
  hasCloseButton: PropTypes.bool,
  hasContentPadding: PropTypes.bool,
  hasHeaderPadding: PropTypes.bool,
  isFooterFixedPosition: PropTypes.bool,
  onClose: PropTypes.func,
  uniqueId: PropTypes.string,
  role: PropTypes.string,
  shouldStackButtons: PropTypes.bool,
  renderContentHeader: PropTypes.func,
  renderFooterContent: PropTypes.func,
  closeOnEsc: PropTypes.bool,
  shouldRenderStickyHeader: PropTypes.bool,
  shouldCloseOnEscapePress: PropTypes.bool,
  customSize: PropTypes.shape(CUSTOM_SIZE_PROP),
  closeButtonSide: PropTypes.oneOf(Object.values(ModalContent.CloseButtonSides)),
  useHairlineDividers: PropTypes.bool
};
ModalContent.defaultProps = {
  size: ModalContent.Sizes.Large,
  headerAlignment: ModalContent.HeaderAlignment.Left,
  actionsFillContainer: false,
  hasContentPadding: true,
  hasCloseButton: true,
  isFooterFixedPosition: true,
  role: 'dialog',
  renderContentHeader: DefaultContentHeader,
  isFullScreenOnMobile: true,
  shouldCloseOnEscapePress: true,
  shouldRenderStickyHeader: true,
  shouldStackButtons: false
};
var ModalContentWithUniqueId = withUniqueId(ModalContent, {
  prefix: PREFIX_ID
});
ModalContentWithUniqueId.propTypes = omit(ModalContent.propTypes, ['uniqueId']);
ModalContentWithUniqueId.defaultProps = ModalContent.defaultProps;
ModalContentWithUniqueId.Sizes = ModalContent.Sizes;
ModalContentWithUniqueId.HeaderAlignment = ModalContent.HeaderAlignment;
ModalContentWithUniqueId.CloseButtonSides = ModalContent.CloseButtonSides;
export default ModalContentWithUniqueId;